import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=5bbeb3e0&"
import script from "./UploadForm.vue?vue&type=script&lang=js&"
export * from "./UploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports